import { switchChain } from "@wagmi/core";
import { SELECTED_NETWORK_LOCAL_STORAGE_KEY } from "config/localStorage";
import { getRainbowKitConfig } from "./rainbowKitConfig";
import { BSC, ChainId } from "config/chains";

// BSC chain (id=56) refers to the legacy v1 deployment we migrated off of. The
// v1 contracts are still live for users to unstake / unwrap MLP / withdraw —
// we serve the frozen v1 frontend at this isolated subdomain so it can't share
// any state (localStorage, IndexedDB, service-worker cache) with the v2 site.
const LEGACY_BSC_URL = "https://legacy.moneyxpro.com";

export type NetworkMetadata = {
  chainId: string;
  chainName: string;
  nativeCurrency: {
    name: string;
    symbol: string;
    decimals: number;
  };
  rpcUrls: string[];
  blockExplorerUrls: string[];
};

export async function switchNetwork(chainId: number, active: boolean): Promise<void> {
  // BSC selection is a legacy-migration shortcut: we DON'T switch the wallet
  // network in the v2 app; instead we open the read-only v1 site in a new tab
  // so the user can unstake / unwrap / withdraw from the old contracts without
  // leaving v2's state. Cross-site state is impossible because legacy.moneyxpro.com
  // is a separate origin.
  if (chainId === BSC) {
    const ok = window.confirm(
      "This is MoneyX v1 — we're migrating to v2 on BESC Hyperchain.\n\n" +
        "Open the v1 site in a new tab?"
    );
    if (ok) {
      window.open(LEGACY_BSC_URL, "_blank", "noopener,noreferrer");
    }
    return;
  }

  if (active) {
    await switchChain(getRainbowKitConfig(), {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      chainId: chainId as any,
    });
    localStorage.setItem(SELECTED_NETWORK_LOCAL_STORAGE_KEY, String(chainId));
  } else {
    // chainId in localStorage allows to switch network even if wallet is not connected
    // or there is no wallet at all
    localStorage.setItem(SELECTED_NETWORK_LOCAL_STORAGE_KEY, String(chainId));
    document.location.reload();
    return;
  }
}

export function shortenAddressOrEns(address: string, length: number) {
  if (!length) {
    return "";
  }
  if (!address) {
    return address;
  }
  if (address.length < 10 || address.length < length) {
    return address;
  }
  let left = address.includes(".") ? address.split(".")[1].length : Math.floor((length - 3) / 2) + 1;
  return address.substring(0, left) + "..." + address.substring(address.length - (length - (left + 3)), address.length);
}
